import {Chart} from './chart';
import {Stage} from './stage';
import 'ui.fonts.opensans';

export const StageFlow = {
	Chart,
	Stage,
};